<script>
import { mapGetters } from 'vuex';
import ReportSearchBlock from '../ReportSearchBlock';

export default {
  name: 'ReportGroupBy',
  mixins: [ReportSearchBlock],
  data() {
    return {
      placeholder: this.schema.placeholder || 'Group by Field',
    };
  },

  computed: {
    ...mapGetters('fields', { fields: 'all' }),

    defaultBucket() {
      let buckets = this.fields || [];
      return buckets.find((f) => f.type === 'default') || {};
    },

    getOptions() {
      let bucket = this.defaultBucket;
      if (!bucket.fields) {
        return [];
      }

      let allowedTypes = this.schema.meta?.types;
      if (!allowedTypes) {
        allowedTypes = ['string'];
      }

      let fields = Object.values(bucket.fields);
      fields = fields.filter((f) => allowedTypes.includes(f.type));
      fields.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });

      return fields.map((field) => {
        return {
          label: field.name,
          value: field.name,
        };
      });
    },

    formattedValue() {
      const multiple = this.schema?.multiple;
      let value = this.value || this.schema.default;

      if (!multiple) {
        return value;
      }

      value = Array.isArray(value) ? value : [value];
      return value.filter((v) => v);
    },
  },
};
</script>
